var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetLogo = function SvgZetLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.21,
    height: 20.21,
    x: 0.895,
    y: 0.893,
    fill: "#2075F0",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M18.001 8h-6.036l.775 1.847h1.786V14h1.705V9.847H18zM8.874 8H4v1.847h2.35L4 12.153V14h4.874v-1.847h-2.35l2.35-2.306zM13.31 12.153h-2.485v-.318h2.346l-.443-1.04-.27-.63h-1.633v-.318h1.482L11.53 8H9.264v6H14.1z"
  })));
};
export default SvgZetLogo;